import React, { useState } from 'react';
import { GoPerson } from 'react-icons/go';
import { IoEyeOutline } from 'react-icons/io5';
import { useSelector } from 'react-redux';

const ListOfUser = () => {
  const { users } = useSelector(state => state.Users);
  const [searchTerm, setSearchTerm] = useState('');

  // Filter users based on search term
  const filteredUsers = users.filter(user =>
    user.email?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <>
      <div className="list-of-user p-5 rounded-xl w-[26vw] h-[56vh] flex flex-col ml-3 mt-3 border border-gray-300 bg-white">
        <h1 className="text-2xl font-bold flex place-content-center">
          List of Users
        </h1>
        {/* Search Input */}
        <input
          type="text"
          placeholder="Search user by email"
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
          className="p-1 mb-2 mt-2 rounded-md border border-gray-300 rounded w-full"
        />
        <div
          className="users h-[42vh] rounded-md flex place-content-center border border-gray-300"
          style={{ backgroundColor: '#eceff4' }}
        >
          <div className="userLists overflow-hidden">
            {filteredUsers.length > 0 ? (
              filteredUsers.map(
                (_user, _index) =>
                  _user.email != undefined && (
                    <div
                      key={_index}
                      className="userList flex justify-between border-b-2 w-[23vw]"
                    >
                      <div
                        className="per text-xl flex justify-start"
                        style={{ color: '#fe104d' }}
                      >
                        <div className="whiteBox m-2 pt-1 bg-white h-6 w-6 rounded flex place-content-center">
                          <GoPerson />
                        </div>
                      </div>
                      <span className="flex justify-center items-center text-lg m-2 overflow-auto">
                        {_user.email}
                      </span>
                      <div
                        className="eye text-xl m-2 pt-1.5 flex justify-end"
                        style={{ color: '#fe104d' }}
                      >
                        {/* <IoEyeOutline /> */}
                      </div>
                    </div>
                  )
              )
            ) : (
              <div className="text-center text-gray-500 mt-2">
                No users found
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ListOfUser;
